export default __webpack_public_path__ + "static/custom-charter-72421c04d24d53ec6801f892f983abd9.jpeg";